import {
  CashOpIdEnum,
  CashOpTypeEnum,
  CashOpTypeTypes,
  CashTypeEnum,
  CashTypeTypes,
  ICashGroupDTO,
  ICashOpDTO,
  ICashTypeDTO,
  ICashValueRetDTO,
} from "@hooks/dtos/ICashDTO";
import { CashGroupIdEnum } from "@hooks/dtos/ICashGroupDTO";

/* eslint-disable no-param-reassign */
const normalizeCashName = (value?: string) =>
  value?.trim().toLowerCase().replace(/\s+/g, " ");

export const cashTypes: ICashTypeDTO[] = [
  {
    type: CashTypeEnum.CREDIT,
    text: "Crédito",
    title: "Crédito",
    color: "success",
  },
  {
    type: CashTypeEnum.DEBIT,
    text: "Débito",
    title: "Débito",
    color: "info",
  },
  {
    type: CashTypeEnum.CANCELED,
    text: "Cancelado",
    title: "Cancelado",
    color: "danger",
  },
  // {
  //   type: CashTypeEnum.HIDDEN,
  //   text: "Oculto",
  //   title: "Oculto",
  //   color: "warning",
  // },
];

export const cashGroups: ICashGroupDTO[] = [
  {
    id: 1,
    name: "Payment",
    text: "Pagamento",
  },
  {
    id: 2,
    name: "Deposit",
    text: "Depósito",
  },
  {
    id: 3,
    name: "Withdraw",
    text: "Saque",
  },
  {
    id: 4,
    name: "Commission",
    text: "Comissão",
  },
  {
    id: 5,
    name: "Fee",
    text: "Taxa",
  },
];

export const cashOps: ICashOpDTO[] = [
  {
    id: CashOpIdEnum.CLIENT_PAY_IN,
    group: CashGroupIdEnum.PAYMENT,
    name: "Client Pay In",
    type: CashOpTypeEnum.CREDIT,
    text: "Pagamento de Cliente",
    title: "Entrada recebida por pagamento de cliente",
    color: "success",
  },
  {
    id: CashOpIdEnum.CUSTOMER_DEPOSIT,
    group: CashGroupIdEnum.DEPOSIT,
    name: "Customer Deposit",
    type: CashOpTypeEnum.CREDIT,
    text: "Depósito",
    title: "Depósito realizado pelo usuário",
    color: "success",
  },
  {
    id: CashOpIdEnum.CUSTOMER_COMMISSION_RECEIVED,
    group: CashGroupIdEnum.COMMISSION,
    name: "Customer Commission Receive",
    type: CashOpTypeEnum.CREDIT,
    text: "Comissão Recebida",
    title: "Comissão recebida pelo usuário",
    color: "success",
  },
  {
    id: CashOpIdEnum.CUSTOMER_TICKET_SALE_PROFIT,
    group: CashGroupIdEnum.PAYMENT,
    name: "Customer Ticket Sale Profit",
    type: CashOpTypeEnum.CREDIT,
    text: "Lucro de Venda",
    title: "Lucro recebido pela venda de ticket",
    color: "success",
  },
  {
    id: CashOpIdEnum.CUSTOMER_WITHDRAW,
    group: CashGroupIdEnum.WITHDRAW,
    name: "Customer Withdraw",
    type: CashOpTypeEnum.DEBIT,
    text: "Saque",
    title: "Saque solicitado pelo usuário",
    color: "warning",
  },
  {
    id: CashOpIdEnum.CUSTOMER_WITHDRAW_FEE,
    group: CashGroupIdEnum.FEE,
    name: "Customer Withdraw Fee",
    type: CashOpTypeEnum.DEBIT,
    text: "Taxa de Saque",
    title: "Taxa cobrada sobre saque",
    color: "warning",
  },
  {
    id: CashOpIdEnum.CUSTOMER_COMMISSION_SENT,
    group: CashGroupIdEnum.COMMISSION,
    name: "Customer Commission Sent",
    type: CashOpTypeEnum.DEBIT,
    text: "Comissão Enviada",
    title: "Comissão enviada para outro usuário",
    color: "warning",
  },
];

export const cashOpTypes: ICashTypeDTO[] = [
  {
    type: CashOpTypeEnum.CREDIT,
    text: "Crédito",
    title: "Crédito",
    color: "success",
  },
  {
    type: CashOpTypeEnum.DEBIT,
    text: "Débito",
    title: "Débito",
    color: "warning",
  },
  {
    type: CashOpTypeEnum.CANCELED,
    text: "Cancelado",
    title: "Cancelado",
    color: "danger",
  },
];

export const getCashTypes = (type: CashTypeTypes): ICashTypeDTO => {
  let ret = cashTypes.find((eventStatusType) => eventStatusType.type === type);
  if (!ret)
    ret = {
      type: "undefined",
      text: "Error",
      title: "Error",
      color: "danger",
    };
  return ret;
};

export const getCashGroup = (group?: number | string): ICashGroupDTO => {
  const normalizedGroup = normalizeCashName(group?.toString());
  let ret = cashGroups.find(
    (cashGroup) =>
      cashGroup.id === Number(group) ||
      normalizeCashName(cashGroup.name) === normalizedGroup,
  );
  if (!ret) ret = { id: 0, name: "Undefined", text: "Não informado" };
  return ret;
};

export const getCashOp = (op?: number | string): ICashOpDTO => {
  const normalizedOp = normalizeCashName(op?.toString());
  let ret = cashOps.find(
    (cashOp) =>
      cashOp.id === Number(op) ||
      normalizeCashName(cashOp.name) === normalizedOp,
  );
  if (!ret)
    ret = {
      id: 0,
      group: 0,
      name: "Undefined",
      type: CashOpTypeEnum.CANCELED,
      text: "Não informado",
      title: "Operação não informada",
      color: "secondary",
    };
  return ret;
};

export const getCashOpType = (type?: CashOpTypeTypes): ICashTypeDTO => {
  let ret = cashOpTypes.find((cashOpType) => cashOpType.type === type);
  if (!ret)
    ret = {
      type: "undefined",
      text: "Não informado",
      title: "Não informado",
      color: "secondary",
    };
  return ret;
};

export const getCashFormattedValue = (
  type: CashTypeTypes,
): ICashValueRetDTO => {
  let ret = {
    sign: "",
    color: "danger",
  };

  switch (type) {
    case CashTypeEnum.CREDIT:
      ret = {
        sign: "+",
        color: "success",
      };
      break;

    case CashTypeEnum.DEBIT:
      ret = {
        sign: "-",
        color: "warning",
      };
      break;

    case CashTypeEnum.CANCELED:
      ret = {
        sign: "-",
        color: "danger",
      };
      break;

    case CashTypeEnum.HIDDEN:
      ret = {
        sign: "",
        color: "info",
      };
      break;
  }

  return ret;
};

